/**
 * 微前端部分逻辑
 */
import {
  // registerMicroApps,
  // start,
  initGlobalState,
  loadMicroApp,
} from "qiankun";

class MicroApp {
  constructor(frames) {
    // 主应用菜单池
    this.frames = frames;
    // 子应用池
    this.appPool = [];
    // 初始化全局state
    this.actions = null;
    this.setGlobalState = null;
    this.state = {};
    this.initActions();
  }

  // 初始化通信方法
  initActions = () => {
    const actions = initGlobalState({
      currentApp: "",
      activeKey: null,
      panes: [],
    });
    actions.onGlobalStateChange((state) => {
      // 缓存状态
      this.state = state;
      // 监听当前panes变化,卸载子应用释放资源
      // this.unmountApp(state.panes);
    });
    const setGlobalStateFunc = actions.setGlobalState;
    this.setGlobalState = setGlobalStateFunc;
  };

  /**
   * 加载微应用
   * @param {*} key 页面key
   * @param {*} appMethods 向子应用共享的函数集合
   */
  loadApp = (key, appMethods) => {
    const appParams = this.frames[key];
    const isMicroApp = typeof appParams === "object" && appParams.isMicroApp;
    // 配置时间戳标记有助于html缓存更新
    appParams.entry = `${appParams.entry.split("?")[0]}?t=${new Date().getTime()}`;
    if (isMicroApp && appParams.entry && appParams.container) {
      // 将当前子应用加入应用池
      if (this.appPool.find((app) => app.info.name === appParams.name)) {
        // return;
      } else {
        const microApp = loadMicroApp(
          {
            ...appParams,
            props: {
              appParams,
              methods: appMethods,
            },
          },
          {
            sandbox: appParams.sandbox
            ? appParams.sandbox
            : {
              experimentalStyleIsolation: true, // 样式隔离
            },
          },
          );
          const app = {
            info: appParams,
            microApp,
            loading: true,
          };
          this.appPool.push(app);
          // microApp.mountPromise.then(() => {
            //   this.setGlobalState({
              //     currentApp: isMicroApp ? appParams.name : null,
              //     activeKey: key,
              //   });
              // });
              return microApp;
            }
          } else {
            // this.setGlobalState({
              //   currentApp: isMicroApp ? appParams.name : null,
      //   activeKey: key,
      // });
      return null;
    }
  };

  // 卸载不活动的app
  unmountApp = (currentPanes) => {
    currentPanes = currentPanes || this.state.panes;
    const activeAPPObj = {};

    currentPanes.forEach((pane) => {
      if (
        typeof pane.content === "object" && pane.content.isMicroApp && !activeAPPObj[pane.content.name]
      ) {
        activeAPPObj[pane.content.name] = pane.content.name;
      }
    });

    this.appPool.forEach((app, index) => {
      if (!activeAPPObj[app.info.name]) {
        app.microApp.unmount();
        this.appPool.splice(index, 1);
      }
    });
  };
}

export {
  //  register,
  // microAppStart,
  // initGlobalState,
  MicroApp,
};



// WEBPACK FOOTER //
// ./src/AntD/microApp.js